module.exports = __webpack_public_path__ + "img/hm.hm0df9060.svg";